import { render, staticRenderFns } from "./BroadcastTab.vue?vue&type=template&id=5b24ce7e&"
import script from "./BroadcastTab.vue?vue&type=script&lang=js&"
export * from "./BroadcastTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b24ce7e')) {
      api.createRecord('5b24ce7e', component.options)
    } else {
      api.reload('5b24ce7e', component.options)
    }
    module.hot.accept("./BroadcastTab.vue?vue&type=template&id=5b24ce7e&", function () {
      api.rerender('5b24ce7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/AccontSettings/BroadcastTab.vue"
export default component.exports